import React from 'react';
import { MarketData } from '../../../types';
import styled from 'styled-components';

interface InfoHeaderProps {
  selectedMarket: MarketData;
  closePopoutButton: React.ReactElement;
}

const InfoHeader = ({ closePopoutButton }: InfoHeaderProps) => {
  return <HeaderContentContainer>{closePopoutButton}</HeaderContentContainer>;
};

const HeaderContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  background-color: #f7f5f3;
`;

export default InfoHeader;
